// extracted by mini-css-extract-plugin
export default {"label":"ImageInput_label__mJ3bF","labelWithIcon":"ImageInput_labelWithIcon__qzjl6"};